// Tabela do Simulador (ZIG-390). Fonte: referencias/Simulador_planos.xlsx, aba "Calculos".
// Guardamos os valores com precisao cheia da planilha para bater ao centavo:
//   - coeficiente: a coluna COEFICIENTE (E). Usada no prazo "D+1" (com antecipacao):
//       cliente paga = valor * coef * parcelas ; lojista recebe = valor / (coef * parcelas).
//   - mdr: a coluna MDR (so o MDR). Usada no prazo "No vencimento" (sem antecipacao)
//       e no debito (que nao antecipa).

export type PlanId = 'ZIG15' | 'ZIG30' | 'ZIG70';

interface Coeficiente {
  avista: number;
  // coeficiente por numero de parcelas (2..21)
  parcelado: Record<number, number>;
}

interface Mdr {
  debito: number;
  avista: number;
  parcelado: Record<number, number>;
}

export interface PlanRates {
  coeficiente: Coeficiente;
  mdr: Mdr;
}

const porParcela = (values: number[]): Record<number, number> =>
  values.reduce<Record<number, number>>((acc, v, i) => {
    acc[i + 2] = v;
    return acc;
  }, {});

export const PLAN_RATES: Record<PlanId, PlanRates> = {
  ZIG15: {
    coeficiente: {
      avista: 1.03562529293254,
      parcelado: porParcela([
        0.5243284881824477, 0.35228582840864586, 0.2671788046945239,
        0.21551611915978755, 0.18105979010350995, 0.15693244079238816,
        0.1385327621296539, 0.12424082833510973, 0.1127747647209587,
        0.10346699766577466, 0.09573753522982244, 0.08889258292521243,
        0.08332498505637613, 0.07846240473225716, 0.07427418880173843,
        0.07059164018994842, 0.06739449209023733, 0.06422909766444543,
        0.06164636808583083, 0.059308869774206366,
      ]),
    },
    mdr: {
      debito: 0.0099,
      avista: 0.01943298707542813,
      parcelado: porParcela([
        0.02417127463108174, 0.024316006460052778, 0.027759715009871015,
        0.028400502598004643, 0.02891631178822535, 0.03238303874612328,
        0.03362091027826458, 0.034948779761661164, 0.035940284803708866,
        0.037564942120736855, 0.03939679798179921, 0.03787467853766586,
        0.0398, 0.0412, 0.0434, 0.0457, 0.049, 0.0477, 0.0505, 0.0532,
      ]),
    },
  },
  ZIG30: {
    coeficiente: {
      avista: 1.0346611478980097,
      parcelado: porParcela([
        0.5236150482859073, 0.35172929363876093, 0.26658089935865564,
        0.2149605483617574, 0.1806084831468213, 0.1564498145958556,
        0.13805644617081034, 0.123712994345651, 0.1123204659882329,
        0.10302328716855311, 0.09530144792747373, 0.08840526595609816,
        0.0828466368297056, 0.07797768770756339, 0.0737904878307614,
        0.07011566516018282, 0.06686134524280991, 0.06382059976248443,
        0.06106703278933401, 0.05894228217320968,
      ]),
    },
    mdr: {
      debito: 0.0099,
      avista: 0.019002499453996607,
      parcelado: porParcela([
        0.023561455488216077, 0.023729423683246934, 0.026769034794653274,
        0.027313036328608518, 0.028145236754869855, 0.031279359898143316,
        0.03239560121306617, 0.03316685519186008, 0.0346, 0.0362, 0.038,
        0.0358, 0.0377, 0.0389, 0.041, 0.0433, 0.0457, 0.0461, 0.0462, 0.0522,
      ]),
    },
  },
  ZIG70: {
    coeficiente: {
      avista: 1.0338326709467063,
      parcelado: porParcela([
        0.5230355160548759, 0.3513739476833181, 0.26599027663986874,
        0.21440078928757253, 0.18005184750940723, 0.15597248576917175,
        0.13755748715495492, 0.1232402864163811, 0.11187250509023564,
        0.10258819373911197, 0.09481760238052235, 0.08799112848364612,
        0.08237949981785282, 0.07757643714819427, 0.07339384814987795,
        0.0696645779877018, 0.06641585894926899, 0.06354728517396219,
        0.0609581941274765, 0.05863916187610322,
      ]),
    },
    mdr: {
      debito: 0.0099,
      avista: 0.0187,
      parcelado: porParcela([
        0.0232, 0.0237, 0.0258, 0.0262, 0.0268, 0.0302, 0.031, 0.0318, 0.0333,
        0.0349, 0.0361, 0.0345, 0.0357, 0.0376, 0.0397, 0.0412, 0.0436, 0.0465,
        0.0492, 0.0522,
      ]),
    },
  },
};

export const MAX_PARCELAS = 21;
